import React from 'react';
import { Tooltip } from '@silverfort/sf-components';

interface Props {
    name: string;
}

const NameColumn: React.FC<Props> = ({ name }) => {
    return (
        <div className="flex justify-between items-center gap-2">
            <Tooltip title={name}>
                <h3 className="text-sm truncate min-w-52 w-52">{name}</h3>
            </Tooltip>
        </div>
    );
};

export default NameColumn;
